export type { LiquidityShare, LiquidityShareMap } from '@skynet/data-liquidity-types';
// Moved to @skynet/data-retainer-overview — re-exported here to keep existing import paths working.
export type {
  AssetInfo,
  JsonRetainersStats,
  RetainersSunburstData,
} from '@skynet/data-retainer-overview';

// The archive commands (`ArchivedRetainers`, `SearchArchivedRetainers`,
// `ShowRetainer`) are owned by @skynet/data-archive's `RetainerArchiveCommands`.
export enum RetainerCommands {
  Listen = 'Listen',
  // RetainerOverview moved to @skynet/data-retainer-overview's own
  // RetainerOverviewCommands enum.
  HideRetainer = 'HideRetainer',
  Projects = 'Projects',
  // SetInitialBalance = 'SetInitialBalance',
  Balances = 'Balances',
}

export interface JsonRetainersPiechartData {
  id: string;
  label: string;
  value: number;
  percentageValue: number;
  color: string;
}
